import { useSelector } from 'react-redux';
import { isObject } from 'lodash/fp';

function useUser() {
  const { hasFetchedUserInfo, user } = useSelector((state) => state.user);
  const isAuthenticated = hasFetchedUserInfo && isObject(user);
  const isDropShipUser = isAuthenticated && user.dropShipPartner === true;

  return {
    hasFetchedUserInfo: hasFetchedUserInfo,
    isAuthenticated: isAuthenticated,
    isDropShipUser: isDropShipUser,
    user: user,
  };
}

export default useUser;
